import React from 'react';

import styles from '../styles/Breadcrumbs.module.css';

const ArrowIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="angle-right-b">
        <path fill="currentColor" d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"></path>
    </svg>
);

export default function Breadcrumbs({ steps }) {
    return (
        <div className={styles.main}>
            {steps.map((step, index) => {
                const isLast = index === steps.length - 1;

                return (
                    <React.Fragment key={index}>
                        <p
                            className={`${styles.stepText} ${isLast ? styles.active : ''}`}
                            onClick={() => !isLast && step.onClick && step.onClick()}
                            style={{ cursor: !isLast && step.onClick ? 'pointer' : 'default' }}
                        >
                            {step.label}
                        </p>

                        {!isLast && (
                            <span className={styles.arrowBetween}>
                                <ArrowIcon />
                            </span>
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
